import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-caret-down",
  "use": "icon-caret-down-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 13\" id=\"icon-caret-down\"><path fill=\"currentColor\" d=\"M6.583 8.535 8.86 5.462a.708.708 0 0 0-.156-.998.728.728 0 0 0-.426-.137H3.722A.718.718 0 0 0 3 5.04c0 .152.049.3.14.422l2.277 3.073a.728.728 0 0 0 1.166 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol